const surveyDetailSelectedTabReducer = (state = "Summary", action) => {
    switch (action.type) {
      case "SET_SURVEY_DETAIL_SELECTED_TAB":
        return action.payload;
      default:
        return state;
    }
  }
  export default surveyDetailSelectedTabReducer;